import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ResourceDownloadService {

    baseUrl =  environment.baseURL;

  apiUrl =
    `${this.baseUrl}api/f/resources/saveLead`;

  constructor(
    private http: HttpClient
  ) {}

  saveLead(data: any): Observable<any> {

    return this.http.post(
      this.apiUrl,
      data
    );

  }

}